"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledFileLoader = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Paperclip = _interopRequireDefault(require("../../icons-react/Paperclip"));
var _types = require("./types");
var _FileLoaderItem = _interopRequireDefault(require("./components/FileLoaderItem"));
var FileLoader = function FileLoader(props) {
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$text = props.text,
    text = _props$text === void 0 ? '' : _props$text,
    _props$errorText = props.errorText,
    errorText = _props$errorText === void 0 ? '' : _props$errorText,
    _props$acceptTypes = props.acceptTypes,
    acceptTypes = _props$acceptTypes === void 0 ? '' : _props$acceptTypes,
    _props$isMobile = props.isMobile,
    isMobile = _props$isMobile === void 0 ? false : _props$isMobile,
    _props$isMultiple = props.isMultiple,
    isMultiple = _props$isMultiple === void 0 ? false : _props$isMultiple,
    _props$showError = props.showError,
    showError = _props$showError === void 0 ? false : _props$showError,
    _props$inputProps = props.inputProps,
    inputProps = _props$inputProps === void 0 ? {} : _props$inputProps,
    _props$onFileListChan = props.onFileListChanged,
    onFileListChanged = _props$onFileListChan === void 0 ? Function.prototype : _props$onFileListChan,
    _props$onFileRemoveCl = props.onFileRemoveClick,
    onFileRemoveClick = _props$onFileRemoveCl === void 0 ? Function.prototype : _props$onFileRemoveCl,
    _props$isFileError = props.isFileError,
    isFileError = _props$isFileError === void 0 ? Function.prototype : _props$isFileError,
    _props$isFileLoading = props.isFileLoading,
    isFileLoading = _props$isFileLoading === void 0 ? Function.prototype : _props$isFileLoading,
    _props$isFileRemoved = props.isFileRemoved,
    isFileRemoved = _props$isFileRemoved === void 0 ? Function.prototype : _props$isFileRemoved;
  var _React$useState = _react["default"].useState([]),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    files = _React$useState2[0],
    setFiles = _React$useState2[1];
  var inputRef = _react["default"].useRef(null);
  var addFilesHandler = function addFilesHandler(e) {
    var inputFiles = e.target.files;
    if (inputFiles === null) {
      return;
    }
    var newFiles = [];
    for (var i = 0; i < inputFiles.length; i += 1) {
      var file = inputFiles[i];
      if (file !== null) {
        newFiles.push(new _types.FileWrapper(file));
      }
    }
    var nextFiles = [].concat((0, _toConsumableArray2["default"])(files), newFiles);
    setFiles(nextFiles);
    onFileListChanged(nextFiles);
  };
  var removeFileHandler = function removeFileHandler(idx) {
    var file = files[idx];
    if (!file) {
      return;
    }
    onFileRemoveClick(file);
  };
  var fakeInputClickHandler = function fakeInputClickHandler() {
    var _inputRef$current, _inputRef$current$cli;
    return inputRef === null || inputRef === void 0 || (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || (_inputRef$current$cli = _inputRef$current.click) === null || _inputRef$current$cli === void 0 ? void 0 : _inputRef$current$cli.call(_inputRef$current);
  };
  return /*#__PURE__*/_react["default"].createElement(StyledFileLoader, null, /*#__PURE__*/_react["default"].createElement(StyledFileLoaderBody, {
    className: className,
    isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement(StyledTitle, {
    onClick: fakeInputClickHandler
  }, /*#__PURE__*/_react["default"].createElement(StyledAttachIcon, null), /*#__PURE__*/_react["default"].createElement(StyledTitleText, null, text), /*#__PURE__*/_react["default"].createElement(StyledHiddenInput, (0, _extends2["default"])({
    multiple: isMultiple,
    accept: acceptTypes
  }, inputProps, {
    ref: inputRef,
    type: "file",
    onChange: addFilesHandler
  }))), files !== null && files !== void 0 && files.length ? files.map(function (f, idx) {
    var id = f.getId();
    var fName = f.getFile().name;
    var isRemoved = isFileRemoved(f);
    var isError = isFileError(f);
    var isLoading = isFileLoading(f);
    if (isRemoved || isError) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement(_FileLoaderItem["default"], {
      key: id,
      text: fName,
      isMobile: isMobile,
      isLoading: isLoading,
      onRemoveClick: function onRemoveClick() {
        return removeFileHandler(idx);
      }
    });
  }) : null), showError ? /*#__PURE__*/_react["default"].createElement(StyledErrorText, null, errorText) : null);
};
var StyledTitleText = _styledComponents["default"].div.withConfig({
  displayName: "FileLoader__StyledTitleText",
  componentId: "sc-jpghhq-0"
})(["font-size:14px;line-height:16px;color:#007aff;transition:opacity 200ms;"]);
var StyledAttachIcon = (0, _styledComponents["default"])(_Paperclip["default"]).withConfig({
  displayName: "FileLoader__StyledAttachIcon",
  componentId: "sc-jpghhq-1"
})(["height:22px;width:22px;"]);
var StyledHiddenInput = _styledComponents["default"].input.withConfig({
  displayName: "FileLoader__StyledHiddenInput",
  componentId: "sc-jpghhq-2"
})(["visibility:hidden;width:0;height:0;"]);
var StyledTitle = _styledComponents["default"].div.withConfig({
  displayName: "FileLoader__StyledTitle",
  componentId: "sc-jpghhq-3"
})(["display:flex;flex-direction:row;align-items:center;height:32px;cursor:pointer;:hover{", "{opacity:0.7;}", "{opacity:0.7;}}"], StyledTitleText, StyledAttachIcon);
var StyledErrorText = _styledComponents["default"].div.withConfig({
  displayName: "FileLoader__StyledErrorText",
  componentId: "sc-jpghhq-4"
})(["font-size:14px;line-height:16px;height:16px;color:#d0021b;margin-top:8px;"]);
var StyledFileLoaderBody = _styledComponents["default"].div.withConfig({
  displayName: "FileLoader__StyledFileLoaderBody",
  componentId: "sc-jpghhq-5"
})(["width:100%;display:flex;align-items:flex-start;flex-direction:", ";", ""], function (_ref) {
  var isMobile = _ref.isMobile;
  return "".concat(isMobile ? 'column' : 'row');
}, function (_ref2) {
  var isMobile = _ref2.isMobile;
  return !isMobile && "\n  flex-wrap: wrap;\n  > * {\n    margin-bottom: 8px;\n    margin-right: 16px;\n  }\n  ";
});
var StyledFileLoader = exports.StyledFileLoader = _styledComponents["default"].div.withConfig({
  displayName: "FileLoader__StyledFileLoader",
  componentId: "sc-jpghhq-6"
})(["display:flex;flex-direction:column;align-items:flex-start;"]);
FileLoader.displayName = 'FileLoader';
var _default = exports["default"] = FileLoader;